import { createScopedLogger } from "../../common/logger";
import { getInteractivePreview } from "./interactivePreview";

const logger = createScopedLogger("DesignMode");

/**
 * Global runtime detection utilities.
 * These are computed once at module load time for optimal performance.
 */

/**
 * Detects if the application is running in designer mode.
 * Designer mode is active when:
 * 1. Running inside an iframe (window.self !== window.top)
 * 2. The parent window is from the portal.randol.io domain
 * This is a one-time check at module load - the value never changes during runtime.
 */
export const IsDesignMode = (() => {
  if (process.env.REACT_APP_RUNTIME_MODE === "embed") {
    return false;
  }
  // Not in iframe - definitely not design mode
  if (window.self === window.top) {
    return false;
  }

  // In iframe - check if parent is portal.randol.io
  try {
    const parentOrigin = document.referrer;
    if (!parentOrigin) {
      // No referrer available, fallback to checking if in iframe
      logger.warn("Cannot verify parent domain - no referrer available");
      return true; // Assume design mode if in iframe but can't verify
    }
    const parentUrl = new URL(parentOrigin);
    const isPortalDomain = parentUrl.hostname === "portal.randol.io" || parentUrl.hostname === "localhost";
    logger.debug("Parent domain:", parentUrl.hostname, "IsDesignMode:", isPortalDomain);
    return isPortalDomain;
  } catch (error) {
    // Error parsing referrer - fallback to iframe check
    logger.warn("Error checking parent domain:", error);
    return true; // Assume design mode if in iframe but can't verify
  }
})();

/** Interactive previews run outside the designer iframe and never apply unsaved designer messages. */
export const InteractivePreview =
  process.env.REACT_APP_RUNTIME_MODE !== "embed" && window.self === window.top
    ? getInteractivePreview(window.location.search)
    : { enabled: false, appId: undefined };
